import { BaseUrl, JsonConfig } from "./BaseRepository";
import axios from 'axios';


export const DeleteGarnishment = async (Id) => {
    try{
        const URL = BaseUrl+"Garnishments/DeleteRecord?recordid="+Id;
        const Response = await axios.delete(URL, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}